define([
  "jquery",
  "marionette",
  "underscore",
  "messaging/messenger",
  "configuration/properties",
  "moment",
  "./template/taskWizardSettingsPageTemplate.html",
  "modules/topicsSplit/topics/topicSearch/topicSearchModel",
], function ($, Marionette, _, Messenger, Properties, moment, TaskWizardSettingsPageTemplate) {
  "use strict";

  const TaskWizardSettingsPageView = {};

  TaskWizardSettingsPageView.settingsPageView = Marionette.Layout.extend({
    className: "form-horizontal task-wizard-settings-page",
    template: TaskWizardSettingsPageTemplate,
    onDomRefresh: function () {
      $(".create-from-template", this.$el).select2({
        allowClear: true,
        placeholder: $.t("task.wizard.chooseTemplate"),
        width: "100%",
      });
      $(".touchpoints", this.$el).select2({
        allowClear: true,
        placeholder: $.t("task.wizard.allTouchpoints"),
        width: "100%",
      });
      $(".existing-topic", this.$el).select2({
        allowClear: true,
        placeholder: $.t("task.wizard.chooseTopic"),
        width: "100%",
        ajax: {
          url: function (params) {
            const kbId = Messenger.reqres.request("active:kb");
            const topicTypes = Messenger.reqres.request("get:topicTypes");
            const topicType = topicTypes.NON_ARCHIVED;
            return (
              `${Properties.rootURL}/${kbId}/` +
              `intents/groups/0/topicType/${topicType}/topic_name/search` +
              `?topicName=${encodeURIComponent(params.term)}`
            );
          },
          processResults: function (data) {
            return {
              results: _.map(data, function (item) {
                return {
                  id: item.intentId,
                  text: item.intentName,
                };
              }),
            };
          },
        },
      });
    },
    events: {
      "change .create-from-template": function (e) {
        let value = $(e.target).val();
        if (value) {
          value = +value;
          this.trigger("create:fromTemplate", value);
        }
      },
      "change .priority": function () {
        let value = this.getPriority();
        this.trigger("change:priority", value);
      },
      "change .start-date": function () {
        let value = this.getStartDate();
        this.trigger("change:startDate", value);
      },
    },
    regions: {
      schedule: ".task-schedule",
      upload: ".task-upload-container",
    },
    templateHelpers: {
      getDateDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:dateUtc", date);
      },
      getDateValue: function (date) {
        return Messenger.reqres.request("get:iso:dateUtc", date);
      },
    },
    ui: {
      dueDate: ".due-date",
      expirationDate: ".expiration-date",
      existingTopic: ".existing-topic",
      interval: ".interval",
      notifyEmails: ".notify-emails",
      primaryLocale: ".primary-locale",
      priority: ".priority",
      startDate: ".start-date",
      taskDescription: ".task-description",
      taskName: ".task-name",
      touchpoints: ".touchpoints",
      nameError: ".task-name-error",
      descriptionError: ".task-description-error",
      startDateError: ".start-date-error",
      dueDateError: ".due-date-error",
    },
    clearErrors: function () {
      this.ui.nameError.html("");
      this.ui.descriptionError.html("");
      this.ui.startDateError.html("");
      this.ui.dueDateError.html("");
    },
    setErrorMessage: function (field, message) {
      this.ui[`${field}Error`]
        .html('<h5 class="error-message">' + message + "</h5>")
        .hide()
        .fadeIn();
    },
    getDueDate: function () {
      return this._getDateInputValue(this.ui.dueDate.val());
    },
    getExpirationDate: function () {
      return this._getDateInputValue(this.ui.expirationDate.val());
    },
    getExistingTopicId: function () {
      if (this.ui.existingTopic.length != 1) {
        return null;
      }
      let value = this.ui.existingTopic.val();
      if (!value) {
        value = 0;
      } else {
        value = +value;
      }
      return value;
    },
    getInterval: function () {
      let value = this.ui.interval.val();
      if (!value) {
        value = 0;
      } else {
        value = +value;
      }
      return value;
    },
    getNotifyEmails: function () {
      const value = this.ui.notifyEmails.val();
      const trimmedValue = value.trim();
      if (value != trimmedValue) {
        this.ui.notifyEmails.val(trimmedValue);
      }
      return trimmedValue;
    },
    getPrimaryLocaleId: function () {
      const value = this.ui.primaryLocale.val();
      if (!value) {
        return 1;
      }
      return +value;
    },
    getPriority: function () {
      let value = this.ui.priority.val();
      if (!value) {
        value = 0;
      } else {
        value = +value;
      }
      return value;
    },
    getStartDate: function () {
      return this._getDateInputValue(this.ui.startDate.val());
    },
    getTaskDescription: function () {
      const value = this.ui.taskDescription.val();
      const trimmedValue = value.trim();
      if (value != trimmedValue) {
        this.ui.taskDescription.val(trimmedValue);
      }
      return trimmedValue;
    },
    getTaskName: function () {
      const value = this.ui.taskName.val();
      const trimmedValue = value.trim();
      if (value != trimmedValue) {
        this.ui.taskName.val(trimmedValue);
      }
      return trimmedValue;
    },
    getTouchpointIds: function () {
      let value = this.ui.touchpoints.val();
      if (!value) {
        return [];
      }
      if (!Array.isArray(value)) {
        value = [value];
      }
      return _.map(value, function (v) {
        return +v;
      });
    },
    setDueDate: function (value) {
      const stringValue = Messenger.reqres.request("get:iso:dateUtc", value);
      this.ui.dueDate.val(stringValue).trigger("change");
    },
    setExistingTopicId: function (intentId) {
      let kbId = Messenger.reqres.request("active:kb");
      $.ajax({
        type: "GET",
        url: Properties.rootURL + "/" + kbId + "/intents/" + intentId,
      }).then((data) => {
        const intentName = data.intentName;
        const option = new Option(intentName, intentId, true, true);
        $(".existing-topic", this.$el)
          .append(option)
          .trigger("change")
          .trigger("select2:select", {
            params: {
              data: {
                id: intentId,
                text: intentName,
              },
            },
          });
      });
    },
    _getDateInputValue: function (value) {
      if (!value) {
        return null;
      }
      // Since we are not displaying the date, only using moment for parsing, then DO NOT USE moment.tz
      // Do force the date to be UTC so it works better with server-side validation
      return moment.utc(value).toDate();
    },
  });

  return TaskWizardSettingsPageView;
});
